<mat-sidenav-container class="w-full">
  <mat-sidenav
    #previewPane
    [fixedInViewport]="true"
    mode="side"
    position="end"
    mode="over"
    (closed)="closePreviewPane()"
    class="max-w-full">
    <sbnb-adjustment-preview-pane
      *ngIf="previewedAdjustment"
      [adjustment]="previewedAdjustment"
      (closed)="closePreviewPane()"
      (applied)="adjustmentApplied.emit()"></sbnb-adjustment-preview-pane>
  </mat-sidenav>

  <ng-container *ngIf="state$ | async as state">
    <!-- Loading state -->
    <div class="flex justify-center" *ngIf="state.loading">
      <sbnb-loading-spinner></sbnb-loading-spinner>
    </div>

    <!-- Error state -->
    <div class="p-4" *ngIf="state.error">
      <p class="text-rose-darker">{{ state.error }}</p>
    </div>

    <!-- Content -->
    <div *ngIf="!state.loading && !state.error">
      <!-- Table -->
      <mat-table *ngIf="state.data" [dataSource]="state.data" class="w-full">
        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef class="max-w-[200px]">Date</mat-header-cell>
          <mat-cell
            *matCellDef="let adjustment"
            class="max-w-[200px]"
            [ngClass]="{
              'text-night': adjustment.status === 'processed' || adjustment.uuid === previewedAdjustment?.uuid
            }">
            {{ adjustment.date | date: 'mediumDate' }}
          </mat-cell>
        </ng-container>

        <!-- Property Column -->
        <ng-container matColumnDef="property">
          <mat-header-cell *matHeaderCellDef>Property</mat-header-cell>
          <mat-cell
            *matCellDef="let adjustment"
            [ngClass]="{
              'text-night': adjustment.status === 'processed' || adjustment.uuid === previewedAdjustment?.uuid
            }">
            {{ adjustment.reservation.property_name }}
          </mat-cell>
        </ng-container>

        <!-- Code Column -->
        <ng-container matColumnDef="code">
          <mat-header-cell *matHeaderCellDef>Code</mat-header-cell>
          <mat-cell
            *matCellDef="let adjustment"
            [ngClass]="{
              'text-night': adjustment.status === 'processed' || adjustment.uuid === previewedAdjustment?.uuid
            }">
            {{ adjustment.reservation.code | uppercase }}
          </mat-cell>
        </ng-container>

        <!-- Guest Column -->
        <ng-container matColumnDef="guest">
          <mat-header-cell *matHeaderCellDef>Guest</mat-header-cell>
          <mat-cell
            *matCellDef="let adjustment"
            [ngClass]="{
              'text-night': adjustment.status === 'processed' || adjustment.uuid === previewedAdjustment?.uuid
            }">
            {{ adjustment.reservation.guest_name }}
          </mat-cell>
        </ng-container>

        <!-- Reason Column -->
        <ng-container matColumnDef="reason">
          <mat-header-cell *matHeaderCellDef>Reason</mat-header-cell>
          <mat-cell
            *matCellDef="let adjustment"
            [ngClass]="{
              'text-night': adjustment.status === 'processed' || adjustment.uuid === previewedAdjustment?.uuid
            }">
            <sbnb-truncate [text]="adjustment.ai_reasoning" class="max-w-[200px]"></sbnb-truncate>
          </mat-cell>
        </ng-container>

        <!-- Amount Column -->
        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef class="justify-end max-w-[200px]">Amount</mat-header-cell>
          <mat-cell
            *matCellDef="let adjustment"
            class="justify-end max-w-[200px]"
            [ngClass]="{
              'text-night': adjustment.status === 'processed' || adjustment.uuid === previewedAdjustment?.uuid
            }">
            <span>
              {{ adjustment.amount | currency: adjustment.reservation.currency }}
            </span>
          </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
          <mat-cell *matCellDef="let adjustment" class="justify-center">
            <sbnb-button size="mini" type="primary-teal" *ngIf="adjustment.status === 'not_processed'">
              Review
            </sbnb-button>
            <sbnb-icon icon="check" *ngIf="adjustment.status === 'processed'" class="text-grass-darker"></sbnb-icon>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          (click)="openPreviewPane(row.uuid)"
          *matRowDef="let row; columns: displayedColumns"
          class="hover:bg-smoke-lighter cursor-pointer"
          [ngClass]="{
            'bg-smoke-lighter': row.uuid === previewedAdjustment?.uuid,
            strong: row.status === 'not_processed'
          }"></mat-row>

        <!-- No Data Row -->
        <tr *matNoDataRow>
          <td colspan="3" class="p-4 text-center">No adjustments available.</td>
        </tr>
      </mat-table>

      <!-- Pagination -->
      <div class="mt-4" *ngIf="pagination$ | async as pagination">
        <sbnb-pagination
          *ngIf="pagination?.totalPages > 1"
          data-element="adjustments-pagination"
          [pageCount]="pagination.totalPages"
          [currentPage]="pagination.currentPage"
          (pageChanged)="onPageChange($event)"></sbnb-pagination>
      </div>
    </div>
  </ng-container>
</mat-sidenav-container>
